import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_URL}/employees`;
const AUTH_BASE = `${process.env.REACT_APP_API_URL}/auth`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const employeeService = {
  // Onboard new employees via registration endpoint
  createEmployee: async (payload) => {
    return await axios.post(`${AUTH_BASE}/register`, payload, getAuthHeaders());
  },

  // Fetches profile for the currently logged-in user
  getMyProfile: async () => {
    try {
      return await axios.get(`${API_BASE}/me`, getAuthHeaders());
    } catch (error) {
      if (error.response?.status === 403) {
        localStorage.removeItem("token");
      }
      throw error;
    }
  },

  // FIXED: Renamed from getById to getEmployeeProfile to perfectly match your React UI calls
  getEmployeeProfile: async (id) => {
    return await axios.get(`${API_BASE}/${id}`, getAuthHeaders());
  },

  // Fetches all employees (HR/Admin only)
  getAllEmployees: async () => {
    return await axios.get(API_BASE, getAuthHeaders());
  },

  // FIXED: Renamed to updateEmployee and changed from .patch to .put to match backend routers
  updateEmployee: async (id, updatedData) => {
    return await axios.put(`${API_BASE}/${id}`, updatedData, getAuthHeaders());
  },

  // 🔥 ADDED: Hard delete/purge method to completely wipe out the record
  purgeEmployee: async (id) => {
    return await axios.delete(`${API_BASE}/${id}`, getAuthHeaders());
  },
};